module.exports = __webpack_public_path__ + "static/media/banner-bg.b1ed4aa2.png";